"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));

var _mobileMenuItem = _interopRequireDefault(require("./mobileMenuItem"));

var _mobileMetamenuItem = _interopRequireDefault(require("./mobileMetamenuItem"));

var _mobileSubContainer = _interopRequireDefault(require("./mobileSubContainer"));

var _mobileSubContent = _interopRequireDefault(require("./mobileSubContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    parent: _defineProperty({
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 0, 1.5),
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 3)
    }, theme.breakpoints.up("lg"), {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 0, 2),
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 6)
    }),
    metamenu: _defineProperty({
      bottom: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
      display: "flex",
      flexWrap: "wrap",
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 2),
      position: "fixed"
    }, theme.breakpoints.up("lg"), {
      bottom: theme === null || theme === void 0 ? void 0 : theme.spacing(2),
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 4)
    })
  };
});

var MobileContent = function MobileContent(_ref) {
  var _mainmenu$items, _metamenu$items;

  var backLabel = _ref.backLabel,
      iconBottom = _ref.iconBottom,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      mainmenu = _ref.mainmenu,
      metamenu = _ref.metamenu;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSubmenu = _useState2[0],
      setShowSubmenu = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hideSubmenu = _useState4[0],
      setHideSubmenu = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      submenuItems = _useState6[0],
      setSubmenuItems = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      mainTitle = _useState8[0],
      setMainTitle = _useState8[1];

  var css = useStyles();
  var theme = (0, _useTheme.default)();
  var animation = {
    hidden: {
      opacity: 0,
      x: -(theme === null || theme === void 0 ? void 0 : theme.spacing(3))
    },
    visible: function visible(i) {
      return {
        opacity: 1,
        transition: {
          delay: i * 0.15 + 0.5
        },
        x: 0
      };
    },
    submenuVisible: {
      opacity: 0,
      x: 0
    },
    hideSubmenu: {
      opacity: 1,
      x: 0
    }
  };
  var animationKey = "";

  if (hideSubmenu) {
    animationKey = "hideSubmenu";
  } else if (showSubmenu) {
    animationKey = "submenuVisible";
  } else {
    animationKey = "visible";
  }

  var animationMetamenu = {
    hidden: {
      opacity: 0,
      y: theme === null || theme === void 0 ? void 0 : theme.spacing(3)
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 1.2
      },
      y: 0
    },
    submenuVisible: {
      opacity: 0,
      y: 0
    },
    hideSubmenu: {
      opacity: 1,
      y: 0
    }
  };
  var animationMetamenuKey = "";

  if (hideSubmenu) {
    animationMetamenuKey = "hideSubmenu";
  } else if (showSubmenu) {
    animationMetamenuKey = "submenuVisible";
  } else {
    animationMetamenuKey = "visible";
  }

  var bigScreen = (0, _useMediaQuery.default)(theme.breakpoints.up("lg"));

  if (bigScreen) {
    animationKey = "visible";
    animationMetamenuKey = "visible";
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mainmenu === null || mainmenu === void 0 ? void 0 : (_mainmenu$items = mainmenu.items) === null || _mainmenu$items === void 0 ? void 0 : _mainmenu$items.map(function (item, i) {
    var _item$icon;

    return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
      className: (0, _clsx.default)("menu-01-mobile-menuitem-parent", css.parent),
      key: item.id,
      custom: i,
      initial: "hidden",
      animate: animationKey,
      variants: animation,
      style: showSubmenu ? {
        pointerEvents: "none"
      } : ""
    }, /*#__PURE__*/_react.default.createElement(_mobileMenuItem.default, {
      click: function click() {
        setShowSubmenu(true);
        setSubmenuItems(item === null || item === void 0 ? void 0 : item.items);
        setMainTitle(item.title);
      },
      hasChildren: item.items && (item === null || item === void 0 ? void 0 : item.items.length) > 0,
      icon: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.filename,
      iconRight: iconRight,
      level: 1,
      link: item.link,
      selected: item.selected,
      target: item.target,
      title: item.title
    }));
  }), showSubmenu && /*#__PURE__*/_react.default.createElement(_mobileSubContainer.default, {
    backIcon: iconLeft,
    backLabel: backLabel,
    close: function close() {
      setSubmenuItems([]);
      setMainTitle("");
      setHideSubmenu(false);
      setShowSubmenu(false);
    },
    onCloseStart: function onCloseStart() {
      setHideSubmenu(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_mobileSubContent.default, {
    iconBottom: iconBottom,
    submenu: submenuItems,
    title: mainTitle
  })), /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    className: (0, _clsx.default)("menu-01-mobile-metamenu", css.metamenu),
    initial: "hidden",
    animate: animationMetamenuKey,
    variants: animationMetamenu
  }, metamenu === null || metamenu === void 0 ? void 0 : (_metamenu$items = metamenu.items) === null || _metamenu$items === void 0 ? void 0 : _metamenu$items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_mobileMetamenuItem.default, {
      key: item.id,
      icon: item.icon,
      id: item.id,
      link: item.link,
      selected: item.selected,
      target: item.target,
      title: item.title
    });
  })));
};

MobileContent.propTypes = {
  backLabel: _propTypes.default.string,
  iconBottom: _propTypes.default.string,
  iconLeft: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  mainmenu: _propTypes.default.object.isRequired,
  metamenu: _propTypes.default.object
};
var _default = MobileContent;
exports.default = _default;